import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faHeart, faCartPlus, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import AccountSidebar from "../../components/AccountSidebar/AccountSidebar";
import { getListProductsApi, removeProductFromListApi } from "../../services/api.services";
import { serverResponse } from "../../util/fakeServer";
import { language } from "../../languageProvider/language/language";
import { defaultLanguage } from "../../helper/utility";
import "../Profile.page.css";

function FavoritesPage(props) {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const user = props.authJWT?.user;
  const listId = user?.listePreferiti?.[0]?.id;

  const fetchFavorites = useCallback(async () => {
    if (!listId) {
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const res = await getListProductsApi(
        listId,
        serverResponse.config.client_id
      );
      if (res.status === 200 && res.data) {
        setProducts(res.data.products || []);
      } else {
        setError(res.message || "Errore nel caricamento dei preferiti");
      }
    } catch (err) {
      setError("Errore nel caricamento dei preferiti");
    } finally {
      setLoading(false);
    }
  }, [listId]);

  useEffect(() => {
    fetchFavorites();
  }, [fetchFavorites]);

  const handleRemove = async (idProduct) => {
    if (!listId) return;
    try {
      await removeProductFromListApi(listId, idProduct);
      setProducts((prev) => prev.filter((p) => p.id_product !== idProduct));
    } catch { /* ignore */ }
  };

  return (
    <div className="up-page">
      <div className="up-topbar">
        <div className="up-topbar__left">
          <div className="up-topbar__back" onClick={() => navigate("/leaflet")}>
            <FontAwesomeIcon icon={faArrowLeft} />
          </div>
          <h1 className="up-topbar__title">{language[defaultLanguage].preferiti}</h1>
        </div>
      </div>

      <div className="up-layout">
        <AccountSidebar />
        <div className="up-main">
          {loading && (
            <div className="up-card" style={{ textAlign: "center", padding: "40px" }}>
              <FontAwesomeIcon icon={faSpinner} spin style={{ fontSize: "1.5rem", color: "#999" }} />
            </div>
          )}

          {error && (
            <div className="up-card" style={{ textAlign: "center", color: "#dc3545" }}>
              <p>{error}</p>
              <button className="up-btn up-btn--outline" onClick={fetchFavorites}>
                Riprova
              </button>
            </div>
          )}

          {!loading && !error && products.length === 0 && (
            <div className="up-card" style={{ textAlign: "center", padding: "40px", color: "#999" }}>
              <FontAwesomeIcon icon={faHeart} style={{ fontSize: "2rem", marginBottom: "10px", color: "#ddd" }} />
              <p>Nessun prodotto nei preferiti</p>
            </div>
          )}

          {!loading && !error && products.length > 0 && (
            <div className="up-card">
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: "14px" }}>
                {products.map((product) => (
                  <div key={product.id} style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "14px",
                    padding: "14px",
                    borderRadius: "12px",
                    border: "1px solid #f0f0f0",
                  }}>
                    <div style={{
                      width: "60px",
                      height: "60px",
                      minWidth: "60px",
                      borderRadius: "10px",
                      backgroundColor: "#f5f5f5",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      overflow: "hidden",
                    }}>
                      {product.image_url ? (
                        <img
                          src={product.image_url}
                          alt={product.product_name}
                          style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        />
                      ) : (
                        <FontAwesomeIcon icon={faHeart} style={{ color: "#ccc", fontSize: "1.2rem" }} />
                      )}
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: "0.92rem", fontWeight: 600, color: "#222", marginBottom: "4px" }}>
                        {product.product_name}
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        {product.prezzo_offerta ? (
                          <>
                            <span style={{ fontSize: "1rem", fontWeight: 700, color: "var(--primary-color)" }}>
                              € {parseFloat(product.prezzo_offerta).toFixed(2)}
                            </span>
                            <span style={{ fontSize: "0.82rem", color: "#999", textDecoration: "line-through" }}>
                              € {parseFloat(product.prezzo).toFixed(2)}
                            </span>
                          </>
                        ) : product.prezzo ? (
                          <span style={{ fontSize: "1rem", fontWeight: 700, color: "var(--primary-color)" }}>
                            € {parseFloat(product.prezzo).toFixed(2)}
                          </span>
                        ) : null}
                      </div>
                      {!product.is_available && (
                        <span style={{ fontSize: "0.75rem", color: "#dc3545" }}>Non disponibile</span>
                      )}
                    </div>
                    <div
                      onClick={() => handleRemove(product.id_product)}
                      style={{
                        width: "36px",
                        height: "36px",
                        minWidth: "36px",
                        borderRadius: "10px",
                        border: "1px solid #ddd",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        color: "#999",
                        fontSize: "0.85rem",
                      }}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  authJWT: state.authJWT,
});

export default connect(mapStateToProps)(FavoritesPage);
